import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import {
  Home,
  PenSquare,
  Newspaper,
  Package,
  Tag,
  ImagePlus,
  LayoutGrid,
  Camera,
  LayoutDashboard,
  Mail,
  GraduationCap,
  Users,
  ShoppingCart,
  Info,
  FileText,
  ExternalLink,
} from 'lucide-react'

// Grouped navigation config — keeps the markup tidy and easy to extend
const navGroups = [
  {
    label: 'Overview',
    items: [{ to: '/admin/home', label: 'Home', icon: Home }],
  },
  {
    label: 'Content',
    items: [
      { to: '/admin/create', label: 'Create blog post', icon: PenSquare },
      { to: '/admin/blog', label: 'Blogs', icon: Newspaper },
      { to: '/admin/portfolio-title', label: 'Portfolio title', icon: Tag },
      { to: '/admin/upload-to-portfolio', label: 'Portfolio images', icon: ImagePlus },
      { to: '/admin/exhibition-title', label: 'Exhibition title', icon: LayoutGrid },
      { to: '/admin/upload-to-exhibition', label: 'Exhibition images', icon: ImagePlus },
      { to: '/admin/on-set', label: 'On set', icon: Camera },
      { to: '/admin/homepage-upload', label: 'Overview', icon: LayoutDashboard },
      { to: '/admin/about', label: 'About', icon: Info },
      { to: '/admin/cv', label: 'CV', icon: FileText },
    ],
  },
  {
    label: 'Shop',
    items: [
      { to: '/admin/upload-product', label: 'Upload product', icon: Package },
      { to: '/admin/orders', label: 'Orders', icon: ShoppingCart },
    ],
  },
  {
    label: 'People',
    items: [
      { to: '/admin/users', label: 'Users', icon: Users },
      { to: '/admin/subscribers', label: 'Subscribers', icon: Mail },
      { to: '/admin/contact', label: 'Contact form', icon: Mail },
      { to: '/admin/academy', label: 'Academy form', icon: GraduationCap },
    ],
  },
]

const linkClasses = ({ isActive }) =>
  `group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors duration-150 justify-center md:justify-start ${
    isActive
      ? 'bg-[#b7a78b] text-neutral-900 font-medium shadow-sm'
      : 'text-neutral-400 hover:bg-neutral-800 hover:text-white'
  }`

const Sidebar = () => {
  return (
    <aside className="sticky top-0 z-10 flex h-screen w-16 shrink-0 flex-col bg-neutral-900 md:w-64">
      {/* Brand */}
      <div className="flex items-center gap-3 border-b border-neutral-800 px-3 py-5 md:px-5">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#b7a78b] text-sm font-bold text-neutral-900">
          SA
        </div>
        <div className="hidden md:block">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-white">
            Sope Adelaja
          </p>
          <p className="mt-0.5 text-xs text-neutral-500">Admin Panel</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 space-y-6 overflow-y-auto px-2 py-5 md:px-3">
        {navGroups.map((group) => (
          <div key={group.label}>
            <p className="hidden px-3 pb-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-neutral-600 md:block">
              {group.label}
            </p>
            <div className="space-y-1">
              {group.items.map(({ to, label, icon: Icon }) => (
                <NavLink key={to} to={to} end className={linkClasses} title={label}>
                  <Icon size={18} className="shrink-0" />
                  <span className="hidden md:inline">{label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="border-t border-neutral-800 px-2 py-4 md:px-3">
        <Link
          to="/"
          title="View site"
          className="flex items-center justify-center gap-3 rounded-lg px-3 py-2.5 text-sm text-neutral-400 transition-colors hover:bg-neutral-800 hover:text-white md:justify-start"
        >
          <ExternalLink size={18} className="shrink-0" />
          <span className="hidden md:inline">View site</span>
        </Link>
      </div>
    </aside>
  )
}

export default Sidebar
